import { themeColours } from "../../resources";
import "./HomePageGuide.css";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { InfoModal } from "./InfoModal";
import { useState } from "react";
const templatePage = require("../../assets/templatePage.png");

export function TemplatePageGuide() {
  const [specificCheck, setSpecificCheck] = useState<boolean>(false);
  const [catCheck, setCatCheck] = useState<boolean>(false);
  return (
    <div className="homePageContainer">
      <img src={templatePage} alt="background" className="background" />
      <InfoModal
        element={
          <span className="specificIcon">
            <IoMdInformationCircleOutline
              size={20}
              color={specificCheck ? themeColours.secondary : themeColours.green}
            />
          </span>
        }
        heading={"Specific Items"}
        texts={[
          <h5 className="modalInfo">
            The best price for that <strong className="extraBold">specific</strong> item at the stores included will be
            added to your cart. Items are matched by their <strong className="extraBold">barcode</strong>.
          </h5>,
        ]}
        onOpenClick={() => setSpecificCheck(true)}
      />
      <InfoModal
        element={
          <span className="catIcon">
            <IoMdInformationCircleOutline size={20} color={catCheck ? themeColours.secondary : themeColours.green} />
          </span>
        }
        heading={"Categorised Items"}
        texts={[
          <h5 className="modalInfo">
            The <strong className="extraBold">store</strong>, <strong className="extraBold">category</strong>, <strong className="extraBold">sub-category</strong>, <strong className="extraBold">brand</strong> and <strong className="extraBold">volume</strong> criteria will be used to add the current{" "}
            <strong className="extraBold">best value</strong> item to your cart.
          </h5>,
        ]}
        onOpenClick={() => setCatCheck(true)}
      />
    </div>
  );
}
